import { render, staticRenderFns } from "./TeamGames.vue?vue&type=template&id=2ba3b80a&"
import script from "./TeamGames.vue?vue&type=script&lang=js&"
export * from "./TeamGames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports